<div class="avatar-wrapper" [style.height]="size" [style.width]="size">
  <span class="avatar-name" [style.fontSize]="fontsize" *ngIf="!image">{{ininame}}</span>
  <img loading="lazy" class="avatar-img" *ngIf="image" [attr.data-src]="image" [default]="util.defaultImg" [alt]="name">
</div>